import { render, staticRenderFns } from "./AppNoteEditor.vue?vue&type=template&id=4b4a2054&scoped=true"
import script from "./AppNoteEditor.vue?vue&type=script&lang=js"
export * from "./AppNoteEditor.vue?vue&type=script&lang=js"
import style0 from "./AppNoteEditor.vue?vue&type=style&index=0&id=4b4a2054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a2054",
  null
  
)

export default component.exports